import React from 'react'
import InitComponent from './Components/InitComponent'
import Nosotros from '../Nosotros/Nosotros'
import Servicios from '../ServiciosDestacados/Servicios'
import Carrusel from '../Eleccion/Carrusel'
import Footer from '../Footer/Footer'

export default function Home() {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center" style={{ fontFamily: "Roboto, sans-serif" }}>
        <InitComponent />
        <Nosotros />
        <Servicios />
        <Carrusel />
        <Footer />
    </div>
  )
}
 